import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';
import { ChevronLeftIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

export const PageHeading: React.FC = () => {
	return (
		<div className="flex flex-col gap-4">
			<Link
				data-qa="subscriptions-manage-back-to-account-settings"
				bold
				href="/account_settings"
				leadingIcon={<ChevronLeftIcon size="small" className="-ml-1" />}
			>
				<Translate value="fe.pages.subscriptions.manage.account_settings" />
			</Link>

			<Text
				className="m-0"
				data-testid="subscriptions-manage-title"
				data-qa="subscriptions-manage-title"
				as="h1"
				variant="heading"
				size="medium"
				fontWeight="bold"
			>
				<Translate value="fe.pages.subscriptions.manage.title" />
			</Text>
		</div>
	);
};
